import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import constants from "../../constants";
import http from "../http";
var serverIPAddress = "139.144.160.21:80/api/v0";

var getCoursePolicy = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var courseId, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            courseId = _ref.courseId;
            _context.next = 3;
            return http.get("".concat(constants.API_URL, "/courses/").concat(courseId, "/gradebook-policy"));

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getCoursePolicy(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var getCourseInfo = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
    var courseId, response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            courseId = _ref3.courseId;
            _context2.next = 3;
            return http.get("".concat(constants.API_URL_V2, "/courses/").concat(courseId));

          case 3:
            response = _context2.sent;
            return _context2.abrupt("return", response);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getCourseInfo(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

var updateCustomVirtualClass = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5) {
    var courseId, data, response;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            courseId = _ref5.courseId, data = _ref5.data;
            _context3.next = 3;
            return http.patch("".concat(constants.API_URL, "/courses/").concat(courseId, "/virtual-class/custom"), data);

          case 3:
            response = _context3.sent;
            return _context3.abrupt("return", response);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function updateCustomVirtualClass(_x3) {
    return _ref6.apply(this, arguments);
  };
}();

var getCustomVirtualClass = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref7) {
    var courseId, response;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            courseId = _ref7.courseId;
            _context4.next = 3;
            return http.get("".concat(constants.API_URL, "/courses/").concat(courseId, "/virtual-class/custom"));

          case 3:
            response = _context4.sent;
            return _context4.abrupt("return", response);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function getCustomVirtualClass(_x4) {
    return _ref8.apply(this, arguments);
  };
}();

var getCourseAnnouncements = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref9) {
    var courseId, response;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            courseId = _ref9.courseId;
            _context5.next = 3;
            return http.get("".concat(constants.API_URL, "/courses/").concat(courseId, "/announcements"));

          case 3:
            response = _context5.sent;
            return _context5.abrupt("return", response);

          case 5:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function getCourseAnnouncements(_x5) {
    return _ref10.apply(this, arguments);
  };
}();

var getCourseMaterials = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref11) {
    var courseId, response;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            courseId = _ref11.courseId;
            _context6.next = 3;
            return http.get("".concat(constants.API_URL_V2, "/courses/").concat(courseId, "/materials"));

          case 3:
            response = _context6.sent;
            return _context6.abrupt("return", response);

          case 5:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function getCourseMaterials(_x6) {
    return _ref12.apply(this, arguments);
  };
}();

var getCourseGrades = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref13) {
    var courseId, response;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            courseId = _ref13.courseId;
            _context7.next = 3;
            return http.get("".concat(constants.API_URL, "/courses/").concat(courseId, "/gradebook/grades"));

          case 3:
            response = _context7.sent;
            return _context7.abrupt("return", response);

          case 5:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function getCourseGrades(_x7) {
    return _ref14.apply(this, arguments);
  };
}();

var createGradableItem = /*#__PURE__*/function () {
  var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref15) {
    var courseId, data, response;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            courseId = _ref15.courseId, data = _ref15.data;
            _context8.next = 3;
            return http.post("".concat(constants.API_URL, "/courses/").concat(courseId, "/gradable-items"), data);

          case 3:
            response = _context8.sent;
            return _context8.abrupt("return", response);

          case 5:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function createGradableItem(_x8) {
    return _ref16.apply(this, arguments);
  };
}();

var getCourseGradableItems = /*#__PURE__*/function () {
  var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref17) {
    var courseId, response;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            courseId = _ref17.courseId;
            _context9.next = 3;
            return http.get("".concat(constants.API_URL, "/courses/").concat(courseId, "/gradable-items"));

          case 3:
            response = _context9.sent;
            return _context9.abrupt("return", response);

          case 5:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function getCourseGradableItems(_x9) {
    return _ref18.apply(this, arguments);
  };
}();

var unshareMaterial = /*#__PURE__*/function () {
  var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(_ref19) {
    var courseId, materialId, response;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            courseId = _ref19.courseId, materialId = _ref19.materialId;
            _context10.next = 3;
            return http.post("".concat(constants.API_URL, "/courses/").concat(courseId, "/materials/").concat(materialId, "/unshare"));

          case 3:
            response = _context10.sent;
            return _context10.abrupt("return", response);

          case 5:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));

  return function unshareMaterial(_x10) {
    return _ref20.apply(this, arguments);
  };
}();

var createFolder = /*#__PURE__*/function () {
  var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(_ref21) {
    var courseId, folder, response;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            courseId = _ref21.courseId, folder = _ref21.folder;
            _context11.next = 3;
            return http.post("".concat(constants.API_URL, "/courses/").concat(courseId, "/materials/folders"), folder);

          case 3:
            response = _context11.sent;
            return _context11.abrupt("return", response);

          case 5:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));

  return function createFolder(_x11) {
    return _ref22.apply(this, arguments);
  };
}();

var createLink = /*#__PURE__*/function () {
  var _ref24 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(_ref23) {
    var courseId, link, response;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            courseId = _ref23.courseId, link = _ref23.link;
            _context12.next = 3;
            return http.post("".concat(constants.API_URL, "/courses/").concat(courseId, "/materials/links"), link);

          case 3:
            response = _context12.sent;
            return _context12.abrupt("return", response);

          case 5:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));

  return function createLink(_x12) {
    return _ref24.apply(this, arguments);
  };
}();

var createFile = /*#__PURE__*/function () {
  var _ref26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(_ref25) {
    var courseId, data, onUploadProgress, response;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            courseId = _ref25.courseId, data = _ref25.data, onUploadProgress = _ref25.onUploadProgress;
            _context13.next = 3;
            return http.post("".concat(constants.API_URL, "/courses/").concat(courseId, "/materials/files"), data, {
              onUploadProgress: onUploadProgress
            });

          case 3:
            response = _context13.sent;
            return _context13.abrupt("return", response);

          case 5:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));

  return function createFile(_x13) {
    return _ref26.apply(this, arguments);
  };
}();

var createNote = /*#__PURE__*/function () {
  var _ref28 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(_ref27) {
    var courseId, data, onUploadProgress, response;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            courseId = _ref27.courseId, data = _ref27.data, onUploadProgress = _ref27.onUploadProgress;
            _context14.next = 3;
            return http.post("".concat(constants.API_URL, "/courses/").concat(courseId, "/materials/notes"), data, {
              onUploadProgress: onUploadProgress
            });

          case 3:
            response = _context14.sent;
            return _context14.abrupt("return", response);

          case 5:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));

  return function createNote(_x14) {
    return _ref28.apply(this, arguments);
  };
}();

var createVirtualClass = /*#__PURE__*/function () {
  var _ref30 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(_ref29) {
    var courseId, response;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            courseId = _ref29.courseId;
            _context15.next = 3;
            return http.post("".concat(constants.API_URL, "/courses/").concat(courseId, "/virtual-class"));

          case 3:
            response = _context15.sent;
            return _context15.abrupt("return", response);

          case 5:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));

  return function createVirtualClass(_x15) {
    return _ref30.apply(this, arguments);
  };
}();

var getAdminVirtualClass = /*#__PURE__*/function () {
  var _ref32 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(_ref31) {
    var courseId, response;
    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            courseId = _ref31.courseId;
            _context16.next = 3;
            return http.post("".concat(constants.API_URL, "/courses/").concat(courseId, "/virtual-class/join-admin"));

          case 3:
            response = _context16.sent;
            return _context16.abrupt("return", response);

          case 5:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));

  return function getAdminVirtualClass(_x16) {
    return _ref32.apply(this, arguments);
  };
}();

var getAttendeeVirtualClass = /*#__PURE__*/function () {
  var _ref34 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(_ref33) {
    var courseId, response;
    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            courseId = _ref33.courseId;
            _context17.next = 3;
            return http.post("".concat(constants.API_URL, "/courses/").concat(courseId, "/virtual-class/join-attendee"));

          case 3:
            response = _context17.sent;
            return _context17.abrupt("return", response);

          case 5:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17);
  }));

  return function getAttendeeVirtualClass(_x17) {
    return _ref34.apply(this, arguments);
  };
}();

var createAssessment = /*#__PURE__*/function () {
  var _ref36 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(_ref35) {
    var courseId, data, onUploadProgress, response;
    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            courseId = _ref35.courseId, data = _ref35.data, onUploadProgress = _ref35.onUploadProgress;
            _context18.next = 3;
            return http.post("".concat(constants.API_URL, "/courses/").concat(courseId, "/assessments"), data, {
              onUploadProgress: onUploadProgress
            });

          case 3:
            response = _context18.sent;
            return _context18.abrupt("return", response);

          case 5:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  }));

  return function createAssessment(_x18) {
    return _ref36.apply(this, arguments);
  };
}();

var getCourseAssessments = /*#__PURE__*/function () {
  var _ref38 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(_ref37) {
    var courseId, response;
    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            courseId = _ref37.courseId;
            _context19.next = 3;
            return http.get("".concat(constants.API_URL, "/courses/").concat(courseId, "/assessments"));

          case 3:
            response = _context19.sent;
            return _context19.abrupt("return", response);

          case 5:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19);
  }));

  return function getCourseAssessments(_x19) {
    return _ref38.apply(this, arguments);
  };
}();

var getStudentSkillGrades = /*#__PURE__*/function () {
  var _ref40 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(_ref39) {
    var courseId, studentId, response;
    return _regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            courseId = _ref39.courseId, studentId = _ref39.studentId;
            _context20.next = 3;
            return http.get("".concat(constants.API_URL, "/courses/").concat(courseId, "/students/").concat(studentId, "/gradable-skills"));

          case 3:
            response = _context20.sent;
            return _context20.abrupt("return", response);

          case 5:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20);
  }));

  return function getStudentSkillGrades(_x20) {
    return _ref40.apply(this, arguments);
  };
}();

var getCourseGradeDefaultView = /*#__PURE__*/function () {
  var _ref42 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(_ref41) {
    var courseId, response;
    return _regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            courseId = _ref41.courseId;
            _context21.next = 3;
            return http.get("".concat(constants.API_URL, "/courses/").concat(courseId, "/grade-default-view"));

          case 3:
            response = _context21.sent;
            return _context21.abrupt("return", response);

          case 5:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21);
  }));

  return function getCourseGradeDefaultView(_x21) {
    return _ref42.apply(this, arguments);
  };
}();

var getGradableSkills = /*#__PURE__*/function () {
  var _ref44 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(_ref43) {
    var courseId, response;
    return _regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            courseId = _ref43.courseId;
            _context22.next = 3;
            return http.get("".concat(constants.API_URL, "/courses/").concat(courseId, "/gradable-skills"));

          case 3:
            response = _context22.sent;
            return _context22.abrupt("return", response);

          case 5:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee22);
  }));

  return function getGradableSkills(_x22) {
    return _ref44.apply(this, arguments);
  };
}();

var getCommonGradeCategories = /*#__PURE__*/function () {
  var _ref46 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(_ref45) {
    var params, response;
    return _regeneratorRuntime.wrap(function _callee23$(_context23) {
      while (1) {
        switch (_context23.prev = _context23.next) {
          case 0:
            params = _ref45.params;
            _context23.next = 3;
            return http.get("".concat(constants.API_URL, "/courses/common-grade-categories/"), {
              params: params
            });

          case 3:
            response = _context23.sent;
            return _context23.abrupt("return", response);

          case 5:
          case "end":
            return _context23.stop();
        }
      }
    }, _callee23);
  }));

  return function getCommonGradeCategories(_x23) {
    return _ref46.apply(this, arguments);
  };
}();

var getCourseHomeworks = /*#__PURE__*/function () {
  var _ref48 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(_ref47) {
    var courseId, response;
    return _regeneratorRuntime.wrap(function _callee24$(_context24) {
      while (1) {
        switch (_context24.prev = _context24.next) {
          case 0:
            courseId = _ref47.courseId;
            _context24.next = 3;
            return http.get("".concat(constants.API_URL, "/courses/").concat(courseId, "/homeworks"));

          case 3:
            response = _context24.sent;
            return _context24.abrupt("return", response);

          case 5:
          case "end":
            return _context24.stop();
        }
      }
    }, _callee24);
  }));

  return function getCourseHomeworks(_x24) {
    return _ref48.apply(this, arguments);
  };
}();

var createHomework = /*#__PURE__*/function () {
  var _ref50 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(_ref49) {
    var data, onUploadProgress, response;
    return _regeneratorRuntime.wrap(function _callee25$(_context25) {
      while (1) {
        switch (_context25.prev = _context25.next) {
          case 0:
            data = _ref49.data, onUploadProgress = _ref49.onUploadProgress;
            _context25.next = 3;
            return http.post("".concat(constants.API_URL, "/courses/homeworks"), data, {
              onUploadProgress: onUploadProgress
            });

          case 3:
            response = _context25.sent;
            return _context25.abrupt("return", response);

          case 5:
          case "end":
            return _context25.stop();
        }
      }
    }, _callee25);
  }));

  return function createHomework(_x25) {
    return _ref50.apply(this, arguments);
  };
}();

var exportCourseGrades = /*#__PURE__*/function () {
  var _ref52 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(_ref51) {
    var courseId, response;
    return _regeneratorRuntime.wrap(function _callee26$(_context26) {
      while (1) {
        switch (_context26.prev = _context26.next) {
          case 0:
            courseId = _ref51.courseId;
            _context26.next = 3;
            return http.get("".concat(constants.API_URL, "/courses/").concat(courseId, "/gradebook/grades/csv"));

          case 3:
            response = _context26.sent;
            return _context26.abrupt("return", response);

          case 5:
          case "end":
            return _context26.stop();
        }
      }
    }, _callee26);
  }));

  return function exportCourseGrades(_x26) {
    return _ref52.apply(this, arguments);
  };
}();

function addStudent(_x27) {
  return _addStudent.apply(this, arguments);
}

function _addStudent() {
  _addStudent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(_ref53) {
    var courseId, studentId, response;
    return _regeneratorRuntime.wrap(function _callee28$(_context28) {
      while (1) {
        switch (_context28.prev = _context28.next) {
          case 0:
            courseId = _ref53.courseId, studentId = _ref53.studentId;
            _context28.next = 3;
            return http.post("".concat(constants.API_URL, "/courses/").concat(courseId, "/students"), {
              studentId: studentId
            });

          case 3:
            response = _context28.sent;
            return _context28.abrupt("return", response);

          case 5:
          case "end":
            return _context28.stop();
        }
      }
    }, _callee28);
  }));
  return _addStudent.apply(this, arguments);
}

function deleteStudent(_x28) {
  return _deleteStudent.apply(this, arguments);
}

function _deleteStudent() {
  _deleteStudent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(_ref54) {
    var courseId, studentId, response;
    return _regeneratorRuntime.wrap(function _callee29$(_context29) {
      while (1) {
        switch (_context29.prev = _context29.next) {
          case 0:
            courseId = _ref54.courseId, studentId = _ref54.studentId;
            _context29.next = 3;
            return http["delete"]("".concat(constants.API_URL, "/courses/").concat(courseId, "/students/").concat(studentId));

          case 3:
            response = _context29.sent;
            return _context29.abrupt("return", response);

          case 5:
          case "end":
            return _context29.stop();
        }
      }
    }, _callee29);
  }));
  return _deleteStudent.apply(this, arguments);
}

function addTeacher(_x29) {
  return _addTeacher.apply(this, arguments);
}

function _addTeacher() {
  _addTeacher = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(_ref55) {
    var courseId, teacherId, response;
    return _regeneratorRuntime.wrap(function _callee30$(_context30) {
      while (1) {
        switch (_context30.prev = _context30.next) {
          case 0:
            courseId = _ref55.courseId, teacherId = _ref55.teacherId;
            _context30.next = 3;
            return http.post("".concat(constants.API_URL, "/courses/").concat(courseId, "/teachers"), {
              teacherId: teacherId
            });

          case 3:
            response = _context30.sent;
            return _context30.abrupt("return", response);

          case 5:
          case "end":
            return _context30.stop();
        }
      }
    }, _callee30);
  }));
  return _addTeacher.apply(this, arguments);
}

function deleteTeacher(_x30) {
  return _deleteTeacher.apply(this, arguments);
}

function _deleteTeacher() {
  _deleteTeacher = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(_ref56) {
    var courseId, teacherId, response;
    return _regeneratorRuntime.wrap(function _callee31$(_context31) {
      while (1) {
        switch (_context31.prev = _context31.next) {
          case 0:
            courseId = _ref56.courseId, teacherId = _ref56.teacherId;
            _context31.next = 3;
            return http["delete"]("".concat(constants.API_URL, "/courses/").concat(courseId, "/teachers/").concat(teacherId));

          case 3:
            response = _context31.sent;
            return _context31.abrupt("return", response);

          case 5:
          case "end":
            return _context31.stop();
        }
      }
    }, _callee31);
  }));
  return _deleteTeacher.apply(this, arguments);
}

function deleteCourse(_x31) {
  return _deleteCourse.apply(this, arguments);
}

function _deleteCourse() {
  _deleteCourse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(_ref57) {
    var courseId, response;
    return _regeneratorRuntime.wrap(function _callee32$(_context32) {
      while (1) {
        switch (_context32.prev = _context32.next) {
          case 0:
            courseId = _ref57.courseId;
            _context32.next = 3;
            return http["delete"]("".concat(constants.API_URL, "/courses/").concat(courseId));

          case 3:
            response = _context32.sent;
            return _context32.abrupt("return", response);

          case 5:
          case "end":
            return _context32.stop();
        }
      }
    }, _callee32);
  }));
  return _deleteCourse.apply(this, arguments);
}

function updateCourse(_x32) {
  return _updateCourse.apply(this, arguments);
}

function _updateCourse() {
  _updateCourse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(_ref58) {
    var courseId, data, response;
    return _regeneratorRuntime.wrap(function _callee33$(_context33) {
      while (1) {
        switch (_context33.prev = _context33.next) {
          case 0:
            courseId = _ref58.courseId, data = _ref58.data;
            _context33.next = 3;
            return http.patch("".concat(constants.API_URL, "/courses/").concat(courseId), data);

          case 3:
            response = _context33.sent;
            return _context33.abrupt("return", response);

          case 5:
          case "end":
            return _context33.stop();
        }
      }
    }, _callee33);
  }));
  return _updateCourse.apply(this, arguments);
}

function getAttendanceSession(_x33) {
  return _getAttendanceSession.apply(this, arguments);
}

function _getAttendanceSession() {
  _getAttendanceSession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34(_ref59) {
    var courseId, params, response;
    return _regeneratorRuntime.wrap(function _callee34$(_context34) {
      while (1) {
        switch (_context34.prev = _context34.next) {
          case 0:
            courseId = _ref59.courseId, params = _ref59.params;
            _context34.next = 3;
            return http.get("".concat(constants.API_URL, "/courses/").concat(courseId, "/attendance-sessions"), {
              params: params
            });

          case 3:
            response = _context34.sent;
            return _context34.abrupt("return", response);

          case 5:
          case "end":
            return _context34.stop();
        }
      }
    }, _callee34);
  }));
  return _getAttendanceSession.apply(this, arguments);
}

function startAttendanceSession(_x34) {
  return _startAttendanceSession.apply(this, arguments);
}

function _startAttendanceSession() {
  _startAttendanceSession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35(_ref60) {
    var courseId, data, response;
    return _regeneratorRuntime.wrap(function _callee35$(_context35) {
      while (1) {
        switch (_context35.prev = _context35.next) {
          case 0:
            courseId = _ref60.courseId, data = _ref60.data;
            _context35.next = 3;
            return http.post("".concat(constants.API_URL, "/courses/").concat(courseId, "/attendance-sessions"), data);

          case 3:
            response = _context35.sent;
            return _context35.abrupt("return", response);

          case 5:
          case "end":
            return _context35.stop();
        }
      }
    }, _callee35);
  }));
  return _startAttendanceSession.apply(this, arguments);
}

function getAttendanceByInterval(_x35) {
  return _getAttendanceByInterval.apply(this, arguments);
}

function _getAttendanceByInterval() {
  _getAttendanceByInterval = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36(_ref61) {
    var courseId, params, response;
    return _regeneratorRuntime.wrap(function _callee36$(_context36) {
      while (1) {
        switch (_context36.prev = _context36.next) {
          case 0:
            courseId = _ref61.courseId, params = _ref61.params;
            _context36.next = 3;
            return http.get("".concat(constants.API_URL, "/courses/").concat(courseId, "/attendance"), {
              params: params
            });

          case 3:
            response = _context36.sent;
            return _context36.abrupt("return", response);

          case 5:
          case "end":
            return _context36.stop();
        }
      }
    }, _callee36);
  }));
  return _getAttendanceByInterval.apply(this, arguments);
}

function getStudentRecord(_x36) {
  return _getStudentRecord.apply(this, arguments);
}

function _getStudentRecord() {
  _getStudentRecord = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37(_ref62) {
    var courseId, studentId, response;
    return _regeneratorRuntime.wrap(function _callee37$(_context37) {
      while (1) {
        switch (_context37.prev = _context37.next) {
          case 0:
            courseId = _ref62.courseId, studentId = _ref62.studentId;
            _context37.next = 3;
            return http.get("".concat(constants.API_URL, "/courses/").concat(courseId, "/students/").concat(studentId, "/attendance-records"));

          case 3:
            response = _context37.sent;
            return _context37.abrupt("return", response);

          case 5:
          case "end":
            return _context37.stop();
        }
      }
    }, _callee37);
  }));
  return _getStudentRecord.apply(this, arguments);
}

function makeStudentGradesAsSeen(_x37) {
  return _makeStudentGradesAsSeen.apply(this, arguments);
}

function _makeStudentGradesAsSeen() {
  _makeStudentGradesAsSeen = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38(_ref63) {
    var courseId, studentId, data, response;
    return _regeneratorRuntime.wrap(function _callee38$(_context38) {
      while (1) {
        switch (_context38.prev = _context38.next) {
          case 0:
            courseId = _ref63.courseId, studentId = _ref63.studentId, data = _ref63.data;
            _context38.next = 3;
            return http.post("".concat(constants.API_URL, "/courses/").concat(courseId, "/students/").concat(studentId, "/grade-categories/seen"), data);

          case 3:
            response = _context38.sent;
            return _context38.abrupt("return", response);

          case 5:
          case "end":
            return _context38.stop();
        }
      }
    }, _callee38);
  }));
  return _makeStudentGradesAsSeen.apply(this, arguments);
}

var createFileToServer = /*#__PURE__*/function () {
  var _ref65 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(_ref64) {
    var courseId, data, onUploadProgress, response;
    return _regeneratorRuntime.wrap(function _callee27$(_context27) {
      while (1) {
        switch (_context27.prev = _context27.next) {
          case 0:
            courseId = _ref64.courseId, data = _ref64.data, onUploadProgress = _ref64.onUploadProgress;
            _context27.next = 3;
            return http.post("".concat(serverIPAddress, "/courses/").concat(courseId, "/materials/files"), data, {
              onUploadProgress: onUploadProgress
            });

          case 3:
            response = _context27.sent;
            return _context27.abrupt("return", response);

          case 5:
          case "end":
            return _context27.stop();
        }
      }
    }, _callee27);
  }));

  return function createFileToServer(_x38) {
    return _ref65.apply(this, arguments);
  };
}();

export default {
  getCoursePolicy: getCoursePolicy,
  getCourseInfo: getCourseInfo,
  getCourseAnnouncements: getCourseAnnouncements,
  getCourseMaterials: getCourseMaterials,
  getCourseGrades: getCourseGrades,
  createGradableItem: createGradableItem,
  getCourseGradableItems: getCourseGradableItems,
  getStudentSkillGrades: getStudentSkillGrades,
  unshareMaterial: unshareMaterial,
  createFolder: createFolder,
  createLink: createLink,
  createFile: createFile,
  createNote: createNote,
  createVirtualClass: createVirtualClass,
  getCustomVirtualClass: getCustomVirtualClass,
  getAdminVirtualClass: getAdminVirtualClass,
  getAttendeeVirtualClass: getAttendeeVirtualClass,
  createAssessment: createAssessment,
  getCourseAssessments: getCourseAssessments,
  updateCustomVirtualClass: updateCustomVirtualClass,
  getCourseGradeDefaultView: getCourseGradeDefaultView,
  getGradableSkills: getGradableSkills,
  getCommonGradeCategories: getCommonGradeCategories,
  getCourseHomeworks: getCourseHomeworks,
  createHomework: createHomework,
  exportCourseGrades: exportCourseGrades,
  addStudent: addStudent,
  deleteStudent: deleteStudent,
  addTeacher: addTeacher,
  deleteTeacher: deleteTeacher,
  deleteCourse: deleteCourse,
  updateCourse: updateCourse,
  getAttendanceSession: getAttendanceSession,
  startAttendanceSession: startAttendanceSession,
  getAttendanceByInterval: getAttendanceByInterval,
  getStudentRecord: getStudentRecord,
  makeStudentGradesAsSeen: makeStudentGradesAsSeen,
  createFileToServer: createFileToServer
};